module.exports = __webpack_public_path__ + "img/logo_01.a47436e2.png";